import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { Flex, FlexCenter, FlexColumn, NumberDisplay, TextBody } from "@opensea/ui-kit";
import { CollectionSweepQuoteReceiptRangeFragment } from "./CollectionSweepQuoteReceiptRange.fragment";
export function getPriceRangeFromQuote(quoteKey, maxAmountOfItems, getPrice) {
  const quote = readFragment(CollectionSweepQuoteReceiptRangeFragment, quoteKey);
  if (quote.quote.__typename === "CollectionSweepQuoteSuccess") {
    const items = quote.quote.itemQuotes;

    // choose the min value, in case the quote returned prices for less than maxAmountOfItems
    const numOfItems = Math.min(maxAmountOfItems, items.length);
    const lowerRange = items.slice(0, numOfItems);
    const upperRange = items.slice(items.length - numOfItems);
    const min = lowerRange.reduce((acc, p) => acc + getPrice(p), 0);
    const max = upperRange.reduce((acc, p) => acc + getPrice(p), 0);
    const tokenSymbol = items[0].pricePerItem.token.symbol;
    return {
      min,
      max,
      tokenSymbol
    };
  }
  return {
    min: 0,
    max: 0,
    tokenSymbol: quote.collection.chain.nativeCurrency.symbol
  };
}
export const CollectionSweepQuoteReceiptRange = t0 => {
  const $ = _c(23);
  const {
    maxAmountOfItems,
    inTooltip,
    quote: quoteKey
  } = t0;
  let t1;
  if ($[0] !== maxAmountOfItems || $[1] !== quoteKey) {
    t1 = getPriceRangeFromQuote(quoteKey, maxAmountOfItems, _temp);
    $[0] = maxAmountOfItems;
    $[1] = quoteKey;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const tokenRange = t1;
  let t2;
  if ($[3] !== maxAmountOfItems || $[4] !== quoteKey) {
    t2 = getPriceRangeFromQuote(quoteKey, maxAmountOfItems, _temp2);
    $[3] = maxAmountOfItems;
    $[4] = quoteKey;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const usdRange = t2;
  if (inTooltip) {
    let t3;
    if ($[6] !== tokenRange.max || $[7] !== tokenRange.tokenSymbol) {
      t3 = <Flex className="flex-row justify-end space-x-2"><TextBody><NumberDisplay suffix={tokenRange.tokenSymbol} value={tokenRange.max} /></TextBody></Flex>;
      $[6] = tokenRange.max;
      $[7] = tokenRange.tokenSymbol;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <TextBody>{"/"}</TextBody>;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    let t5;
    if ($[10] !== usdRange.max) {
      t5 = <Flex className="flex-row justify-end space-x-2"><TextBody><NumberDisplay display="usd" value={usdRange.max} /></TextBody></Flex>;
      $[10] = usdRange.max;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    let t6;
    if ($[12] !== t3 || $[13] !== t5) {
      t6 = <FlexCenter className="grow gap-2 first:pl-0">{t3}{t4}{t5}</FlexCenter>;
      $[12] = t3;
      $[13] = t5;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    return t6;
  }
  let t3;
  if ($[15] !== tokenRange.min || $[16] !== tokenRange.tokenSymbol) {
    t3 = <Flex className="flex-row justify-end space-x-2"><TextBody weight="semibold"><NumberDisplay suffix={tokenRange.tokenSymbol} value={tokenRange.min} /></TextBody></Flex>;
    $[15] = tokenRange.min;
    $[16] = tokenRange.tokenSymbol;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] !== usdRange.min) {
    t4 = <Flex className="flex-row justify-end space-x-2"><TextBody className="font-mono" color="text-secondary"><NumberDisplay display="usd" value={usdRange.min} /></TextBody></Flex>;
    $[18] = usdRange.min;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] !== t3 || $[21] !== t4) {
    t5 = <FlexColumn className="grow first:pl-0">{t3}{t4}</FlexColumn>;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  return t5;
};
function _temp(item) {
  return item.pricePerItem.token.unit;
}
function _temp2(item_0) {
  return item_0.pricePerItem.usd;
}